<form [formGroup]="parentForm" class="column-layout">
  <div class="select-field-container">
    <div>Credit Tier</div>
    <select
      class="form-control border border-primary color w-50 h-28"
      [formControlName]="formCtrlName"
      (change)="change()">
      <option value="" disabled>Select Credit Tier</option>
      <option *ngFor="let option of creditTiers" [value]="option.tier">{{ option.name }}</option>
    </select>
  </div>
</form>
